<div class="text-xs">
  <div class="font-semibold text-foreground-primary-40">{{ label() }}</div>

  @if (part().pendingConsentId && !part().consentDecision) {
    <div class="mt-2">
      <app-ai-consent-buttons (decided)="onConsentDecision($event)" />
    </div>
  }
</div>
